// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-01-24 02:54:28 +0100 (Sat, 24 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159989 $
//  Purpose   : auth support
// =============================================================================
export const parts = true;
import * as actions from './actions';
export { actions };
import * as reducers from './reducers';
export { reducers };
import { includes } from 'ldash';
export const hasGroup = ({ dname, user, name })=>{
    // check if current user is in group
    return user && (includes(user.groups, name) || dname && user.localgroups && includes(user.localgroups[dname], name));
};
const views = {
    // non-server-side routed view for loginDialog
    // could alternativly solved directly in templating/view.js
    xauth: {
        tabs: {
            loginDialog: {
                tabGroup: null,
                parts: [
                    'AuthLogin'
                ],
                layout: 'blank'
            }
        }
    }
};
export { views };
